module.exports = __webpack_public_path__ + "2630a3e3eab21c607e21576571b95b9d.svg";